var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallInsta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_6232",
    "data-name": "Groupe 6232",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.712,
    height: 20.712,
    viewBox: "0 0 20.712 20.712",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.945,
    y1: 0.06,
    x2: 3.304,
    y2: 1.116,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7166"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_303",
    "data-name": "Trac\\xE9 303",
    d: "M10.356,0A10.356,10.356,0,1,1,0,10.356,10.356,10.356,0,0,1,10.356,0Z",
    fill: "url(#linear-gradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram",
    transform: "translate(4.999 4.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_135",
    "data-name": "Trac\\xE9 135",
    d: "M10.966,3.1a3.853,3.853,0,0,0-.245-1.279A2.7,2.7,0,0,0,9.177.278,3.863,3.863,0,0,0,7.9.033C7.334.006,7.154,0,5.723,0S4.112.006,3.549.031A3.855,3.855,0,0,0,2.27.276a2.573,2.573,0,0,0-.935.61,2.6,2.6,0,0,0-.608.933A3.864,3.864,0,0,0,.482,3.1c-.027.565-.033.744-.033,2.176S.455,6.885.479,7.447A3.853,3.853,0,0,0,.725,8.727,2.7,2.7,0,0,0,2.268,10.27a3.864,3.864,0,0,0,1.279.245c.562.025.742.031,2.173.031s1.611-.006,2.173-.031a3.853,3.853,0,0,0,1.279-.245,2.7,2.7,0,0,0,1.543-1.543,3.866,3.866,0,0,0,.245-1.279c.025-.562.031-.742.031-2.173s0-1.611-.027-2.173Zm-.95,4.306a2.891,2.891,0,0,1-.181.979,1.749,1.749,0,0,1-1,1,2.9,2.9,0,0,1-.979.181c-.556.025-.723.031-2.13.031s-1.576-.006-2.13-.031a2.889,2.889,0,0,1-.979-.181,1.623,1.623,0,0,1-.606-.394,1.64,1.64,0,0,1-.394-.606,2.9,2.9,0,0,1-.181-.979c-.025-.556-.031-.723-.031-2.13s.006-1.576.031-2.13a2.889,2.889,0,0,1,.181-.979,1.6,1.6,0,0,1,.4-.606,1.637,1.637,0,0,1,.606-.393A2.9,2.9,0,0,1,3.6.989C4.153.964,4.32.958,5.727.958S7.3.964,7.857.989a2.891,2.891,0,0,1,.979.181,1.622,1.622,0,0,1,.606.393,1.639,1.639,0,0,1,.394.606,2.9,2.9,0,0,1,.181.979c.025.556.031.723.031,2.13s-.006,1.572-.031,2.128Zm0,0",
    transform: "translate(-0.449 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_136",
    "data-name": "Trac\\xE9 136",
    d: "M127.658,124.5a2.709,2.709,0,1,0,2.709,2.709A2.71,2.71,0,0,0,127.658,124.5Zm0,4.466a1.757,1.757,0,1,1,1.757-1.757A1.758,1.758,0,0,1,127.658,128.966Zm0,0",
    transform: "translate(-122.384 -121.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_137",
    "data-name": "Trac\\xE9 137",
    d: "M363.715,89.234a.632.632,0,1,1-.633-.632A.633.633,0,0,1,363.715,89.234Zm0,0",
    transform: "translate(-354.992 -86.776)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallInsta);
export default __webpack_public_path__ + "static/media/small-insta.68d2d5bb0a2c4e3052b0edbc4c79d383.svg";
export { ForwardRef as ReactComponent };